import React, {useEffect, useState, Fragment, useRef} from 'react';
import {connect} from "react-redux";
import GLBViewer from "./GLBViewer";
import LightIntensitySlider from "./LightIntensitySlider";
import LightingSwitch from "./LightingSwitch";
// import ExportButton from "./ExportButton";
import SqftStore from "../canvas/store/sqftStore";

const ShapesThreeJsViewer = (props) => {
  const {cabinetsGlb} = props;
  const canvasRef = useRef(null); // Changed to useRef for consistency
  const viewGLRef = useRef(null); // Use a ref to persist the GLBViewer instance
  const [lightIntensity, setLightIntensity] = useState(800);
  const [lightingType, setLightingType] = useState('addLightV4');
  void lightingType
  const minLightningValue = 0;
  const maxLightningValue = 2000;
  // const [lightIntensity, setLightIntensity] = useState(130); //for v5
  // const minLightningValue = 0;
  // const maxLightningValue = 500;

  useEffect(() => {
    if (cabinetsGlb && canvasRef.current && !viewGLRef.current) {
      const viewGL = new GLBViewer(canvasRef.current, cabinetsGlb, lightIntensity);
      viewGLRef.current = viewGL;
      SqftStore.viewGL = viewGL;

      // ******************* EVENT LISTENERS ******************* //
      // const onMouseMove = (event) => {
      //   viewGL.onMouseMove(event);
      // }
      // const onMouseDown = (event) => {
      //   viewGL.onMouseDown(event);
      // }
      // const onMouseUp = (event) => {
      //   viewGL.onMouseUp(event);
      // }
      // const onWheel = (event) => {
      //   viewGL.onWheel(event);
      // }
      const handleResize = () => {
        viewGL.onWindowResize(window.innerWidth, window.innerHeight);
      };

      // ******************* INIT LISTENERS *******************
      // canvas.addEventListener('mousemove', onMouseMove);
      // canvas.addEventListener('mousedown', onMouseDown);
      // canvas.addEventListener('mouseup', onMouseUp);
      // canvas.addEventListener('wheel', onWheel);
      window.addEventListener('resize', handleResize);
      handleResize()

      return () => {
        // Stop animation
        viewGL.stop();
        // Dispose resources
        viewGL.dispose();
        viewGLRef.current = null;
        SqftStore.viewGL = null;

        // Remove any event listeners
        // canvas.removeEventListener('mousemove', onMouseMove);
        // canvas.removeEventListener('mousedown', onMouseDown);
        // canvas.removeEventListener('mouseup', onMouseUp);
        // canvas.removeEventListener('wheel', onWheel);
        window.removeEventListener('resize', handleResize);
        SqftStore.viewGL = null;
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [canvasRef, cabinetsGlb])

  useEffect(() => {
    // Pass updated props to
    // const newValue = this.props.whateverProperty;
    // this.viewGL.updateValue(newValue);
    if (viewGLRef.current) {
      viewGLRef.current.updateLightIntensity(lightIntensity);
    }
  }, [lightIntensity])

  return (
    <Fragment>
      <LightIntensitySlider
        intensity={lightIntensity}
        minValue={minLightningValue}
        maxValue={maxLightningValue}
        setIntensity={setLightIntensity} />
      {/*<ExportButton/>*/}
      <LightingSwitch viewGLRef={viewGLRef} setLightingType={setLightingType} />
      <canvas ref={canvasRef} />
    </Fragment>
  );
}

const mapStateToProps = (store) => ({
  cabinetsGlb: store.sqftState.cabinetsGlb,
});

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(ShapesThreeJsViewer);
